/**
 * CookieBanner — Bandeau de consentement cookies RGPD
 * Conforme RGPD et ePrivacy
 */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const COOKIE_KEY = 'wl_cookie_consent';

export default function CookieBanner() {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'fr';
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setTimeout(() => setVisible(true), 1500);
  }, []);

  const accept = () => { localStorage.setItem(COOKIE_KEY, 'accepted'); setVisible(false); };
  const decline = () => { localStorage.setItem(COOKIE_KEY, 'declined'); setVisible(false); };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      zIndex: 9998, padding: '0 16px 16px',
    }}>
      <div style={{
        background: '#fff', borderRadius: '16px 16px 0 0',
        boxShadow: '0 -4px 32px rgba(0,0,0,0.12)',
        padding: '20px', maxWidth: '600px', margin: '0 auto',
        border: '1px solid #E5E7EB',
      }}>
        <p style={{ fontWeight: 600, fontSize: 14, marginBottom: 8, color: '#111827' }}>
          🍪 {lang === 'fr' ? 'Cookies & Confidentialité' : 'Cookies & Privacy'}
        </p>
        <p style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.6, marginBottom: 12 }}>
          {lang === 'fr'
            ? "Nous utilisons des cookies essentiels au fonctionnement de l'application (authentification, préférences). Aucun cookie publicitaire n'est utilisé."
            : "We use essential cookies for the app to work (authentication, preferences). No advertising cookies are used."}
        </p>
        <a href="/terms" style={{ fontSize: 12, color: '#0068B9', display: 'block', marginBottom: 16 }}>
          {lang === 'fr' ? 'Politique de confidentialité →' : 'Privacy policy →'}
        </a>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={decline} style={{
            flex: 1, padding: '10px', borderRadius: 10,
            border: '2px solid #E5E7EB', background: '#fff',
            color: '#374151', fontSize: 13, fontWeight: 600, cursor: 'pointer',
          }}>
            {lang === 'fr' ? 'Refuser' : 'Decline'}
          </button>
          <button onClick={accept} style={{
            flex: 1, padding: '10px', borderRadius: 10,
            border: 'none', background: '#0068B9',
            color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
          }}>
            {lang === 'fr' ? 'Accepter' : 'Accept'}
          </button>
        </div>
        <p style={{ fontSize: 10, color: '#9CA3AF', textAlign: 'center', marginTop: 8 }}>
          {lang === 'fr' ? 'Conformément au RGPD' : 'In accordance with GDPR'}
        </p>
      </div>
    </div>
  );
}
